export default {
  produtos(state) {
    return state.produtos;
  },
};
